import { FunctionComponent, useEffect, useState } from "react";
import { Icon } from "../../Icon";
import "./styles.scss";
type Props = {};

const BackToTop: FunctionComponent<Props> = ({}) => {
  const [showScroll, setShowScroll] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", checkScrollTop);
    return () => {
      window.removeEventListener("scroll", checkScrollTop);
    };
  }, []);

  const checkScrollTop = () => {
    if (!showScroll && window.pageYOffset > 400) {
      setShowScroll(true);
    } else if (
      (showScroll && window.pageYOffset <= 400) ||
      window.pageYOffset === 0
    ) {
      setShowScroll(false);
    }
  };

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "auto" });
  };
  return (
    <>
      {showScroll && (
        <div className="back-to-top" onClick={scrollTop}>
          <Icon iconName="go-to-arrow" className="back-to-top__icon" />
        </div>
      )}
    </>
  );
};

export default BackToTop;
